import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  gap: 10px;
  padding: 20px;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;

  gap: 10px;
`;

export const Title = styled.span`
  font-weight: 700;
  font-size: 20px;
`;
export const Subtitle = styled.span`
  font-weight: 700;
  font-size: 15px;

  color: ${props => props.theme.colors.grey_text}
`;

export const Observacao = styled.span`
  font-size: 12px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const SetpTwoContainer = styled.div`
  display: flex;
  flex-direction: column;

  gap: 10px;
`;

export const Codewrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
`;

export const PixCode = styled.div`
  width: 100%;
  overflow: hidden;
  padding: 10px;

  display: flex;
  flex-direction: column;
  gap: 20
`;

export const Code = styled.span`
  word-wrap: break-word;
  white-space: normal;
  overflow: hidden;
`;

